import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import {
    DEFAULT_ROUTE,
    ROUTE_CONFLOGIC,
    ROUTE_TEMPLATES,
    ROUTE_TRANSLATIONS
} from 'src/routes/Router';
import { detectFeatureToggles } from 'src/configuration/setup/featureToggles';
import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { accessToken } from 'src/configuration/tokenHandling/accessToken';
import useClipboard from '@rio-cloud/rio-uikit/useClipboard';
import { useRef } from 'react';
import { getUserProfile } from 'src/configuration/login/loginSlice';
import { useAppSelector } from 'src/configuration/setup/hooks';

const AppHeader = () => {
    const headerRef = useRef<HTMLDivElement>(null);
    const userProfile = useAppSelector(getUserProfile);
    const {
        useTemplates,
        // useConfLogic,
        // useTranslations
    } = detectFeatureToggles();
    const clipboard = useClipboard();
    const navItems = [
        {
            key: 'intro',
            route: (
                <NavLink to={DEFAULT_ROUTE}>
                    <FormattedMessage id={'intl-msg:starterTemplate.sublink.intro'} />
                </NavLink>
            ),
        },
    ].filter(Boolean);
    // if (useConfLogic) {
    navItems.push({
        key: 'conflogic',
        route: (
            <NavLink to={ROUTE_CONFLOGIC}>
                <FormattedMessage id={'intl-msg:starterTemplate.sublink.conflogic'} />
            </NavLink>
        ),
    });
    // }
    if (useTemplates) {
        navItems.push({
            key: 'templates',
            route: (
                <NavLink to={ROUTE_TEMPLATES}>
                    <FormattedMessage id={'intl-msg:starterTemplate.sublink.templates'} />
                </NavLink>
            ),
        });
    }
    // if (useTranslations) {
    navItems.push({
        key: 'translations',
        route: (
            <NavLink to={ROUTE_TRANSLATIONS}>
                <FormattedMessage id={'intl-msg:starterTemplate.sublink.translations'} />
            </NavLink>
        ),
    });
    // }
    const actionBarItems = [
        <ActionBarItem id='userMenu' key={'userMenu'}>
            <ActionBarItem.Icon>
                <span className='icon rioglyph rioglyph rioglyph-cards-list' />
            </ActionBarItem.Icon>
            <ActionBarItem.Popover useOffscreen>
                <h6>Actions</h6>
                <div>
                    <button
                        type='button'
                        className='btn btn-link'
                        onClick={() => clipboard.copy(`Bearer ${accessToken.getAccessToken()}`)}
                    >
                        <span className='rioglyph rioglyph-duplicate' aria-hidden='true' />
                        <span className='text-primary' aria-hidden='true'>
                            <FormattedMessage id='intl-msg:copyAccessToken' />
                        </span>
                    </button>
                </div>
                <div className='border-style-solid border-width-1 border-color-lighter border-top-only margin-left-10 margin-top-20 padding-top-10' />
                <h6>User</h6>
                <div>
                    {userProfile?.name && (
                        <button type='button' className='btn btn-link'>
                            <span className='rioglyph rioglyph-user' aria-hidden='true' />
                            <span className='text-primary' aria-hidden='true'>
                                {userProfile.name}
                            </span>
                        </button>
                    )}
                </div>
            </ActionBarItem.Popover>
        </ActionBarItem>,
    ];
    return (
        <ApplicationHeader
            ref={headerRef}
            label={<FormattedMessage id='intl-msg:starterTemplate.moduleName' />}
            homeRoute={<NavLink to='/' />}
            // appNavigator={fakeAppNavigator}
            appNavigatorClassName='appNavigatorClassName'
            navItems={navItems}
            // onToggleAppMenu={(isMenuOpen) => console.log({ isMenuOpen })}
            // actionBarItems={[sampleActionBarComponent, AccountMenuComponent]}
            actionBarItems={[actionBarItems]}
        />
    );
};

export default AppHeader;
